import withRouter from "hoc/withRouter";
import {
  Button,
  Chip,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import baggageService from "services/admin/baggageService";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { baggageStatusLabel } from "./baggage-status";

const BaggageList = ({ router }: any) => {
  console.log("router? ", router);
  const orgID = localStorage.getItem("orgID") || "";
  const tripID = router?.queryParams?.get("tripID") || "";

  const {
    data: baggageResponse,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["baggages", { orgID, tripID }],
    queryFn: async () => {
      const response: any = await baggageService.getAll(tripID ? { tripID } : {});
      return response.data;
    },
  });

  const handleDelete = async (id: string) => {
    if (!window.confirm("Удалить место багажа?")) return;
    await baggageService.delete(id);
    refetch();
  };

  function buildContent() {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress></CircularProgress>
        </div>
      );
    }
    const rows: any[] = (baggageResponse as any)?.data || [];
    if (rows.length === 0) {
      return (
        <div>
          Багаж отсутствует. Чтобы зарегистрировать место, нажмите на кнопку "Добавить" сверху
        </div>
      );
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Бирка</TableCell>
            <TableCell>Тип</TableCell>
            <TableCell>Вес</TableCell>
            <TableCell>Маршрут</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((c: any, index: number) => (
            <TableRow key={c.id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{c.tagCode}</TableCell>
              <TableCell>{c.type}</TableCell>
              <TableCell>{c.weight != null ? `${Number(c.weight)} кг` : "—"}</TableCell>
              <TableCell>
                {c.trip?.originStation?.name || "—"} → {c.trip?.destinationStation?.name || "—"}
              </TableCell>
              <TableCell>
                <Chip size="small" label={baggageStatusLabel(c.status)} />
              </TableCell>
              <TableCell>
                <div className="flex gap-2 items-center">
                  <Link to={`/admin/baggages/detail/${c.id}`}>
                    <Button size="small">Открыть</Button>
                  </Link>
                  <Link to={`/admin/baggages/edit/${c.id}`}>
                    <FaPencil />
                  </Link>
                  <IconButton color="error" onClick={() => handleDelete(c.id)}>
                    <FaTrashAlt />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
  return (
    <ListPage pageTitle="Багаж" pathToAdd={`/admin/baggages/add`}>
      <div className="m-t-32">{buildContent()}</div>
    </ListPage>
  );
};

export default withRouter(BaggageList);
